import createModel from 'utils/model'
import dayjs from 'dayjs'
import constants from 'crm/common/constants'
import {
    statByDate,
    statByUser,
    exportStatByDate,
    exportStatByUser,
} from 'crm/services/stat-customer'

const {dateFormat} = constants

function getInitParams() {
    return {
        department_id: undefined,
        user_id: undefined,
        state: undefined, // 渠道 id
        // 不包含今天
        date_from: dayjs().subtract(7, 'days').format(dateFormat),
        date_to: dayjs().subtract(1, 'days').format(dateFormat),
    }
}

function getFilledData(data, from, to) {
    const addition = []
    let startTime = dayjs(from)
    const endTime = dayjs(to)
    const diff = endTime.diff(startTime, 'days') + 1
    if (data.length === diff) {
        return data
    }
    for (let i = 1; i <= diff; i++) {
        const year = startTime.year()
        let month = startTime.month() + 1
        let day = startTime.date()

        month = month < 10 ? `0${month}` : month
        day = day < 10 ? `0${day}` : day
        addition.push({
            st_date: `${year}-${month}-${day}`,
        })
        startTime = startTime.add(1, 'day')
    }

    return addition
        .map((item) => {
            const temp = data.find((v) => v.st_date === item.st_date)
            if (temp) {
                return {
                    ...item,
                    ...temp,
                }
            }
            return item
        })
        .reverse()
}

export default createModel({
    namespace: 'crm_statCustomer',

    state: {
        params: getInitParams(),
        data: [],
        chartData: {},
        statType: 'date',
    },

    effects: {
        *statByDate({payload}, {call, put, select}) {
            const params = yield select(({crm_statCustomer}) => crm_statCustomer.params)
            const query = {...params, ...payload.params}

            const res = yield call(statByDate, query)
            if (res && res.data) {
                const {data} = res

                let filledData = []

                if (query.date_from && query.date_to) {
                    filledData = getFilledData(data, query.date_from, query.date_to)
                } else {
                    filledData = data
                }

                const totalData = []
                const netIncData = []
                const incData = []
                const delData = []
                const blockData = []

                filledData.forEach((item) => {
                    const date = item.st_date.substring(5)
                    totalData.push({
                        date,
                        value: item.total_count,
                    })
                    netIncData.push({
                        date,
                        value: item.growth,
                    })
                    incData.push({
                        date,
                        value: item.inc_count,
                    })
                    delData.push({
                        date,
                        value: item.del_count,
                    })
                    blockData.push({
                        date,
                        value: item.block_count,
                    })
                })

                yield put({
                    type: 'setProperty',
                    payload: {
                        data,
                        params: query,
                        filledData,
                        chartData: {
                            total_count: totalData,
                            inc_count: incData,
                            growth: netIncData,
                            del_count: delData,
                            block_count: blockData,
                        },
                    },
                })
            }
        },
        *statByUser({payload}, {call, put, select}) {
            const params = yield select(({crm_statCustomer}) => crm_statCustomer.params)
            const query = {...params, ...payload.params}
            const res = yield call(statByUser, query)
            if (res && res.data) {
                const {data} = res

                yield put({
                    type: 'setProperty',
                    payload: {
                        data,
                        params: query,
                        filledData: data,
                    },
                })
            }
        },
        *exportStatByDate(_, {call, select}) {
            const params = yield select(({crm_statCustomer}) => crm_statCustomer.params)
            return yield call(exportStatByDate, params)
        },
        *exportStatByUser(_, {call, select}) {
            const params = yield select(({crm_statCustomer}) => crm_statCustomer.params)
            return yield call(exportStatByUser, params)
        },
    },

    reducers: {},
})
